import React, { Component } from 'react'
import './faqs.css'

const faqs = [
  {
    title: '¿Qué significa exactamente “dieta personalizada”?',
    description:
      'Significa que tu plan no es genérico ni automático. Se construye según tus datos reales: edad, peso, estatura, objetivos, nivel de actividad, hábitos y preferencias alimentarias. No comes lo mismo que otra persona.',
  },
  {
    title: '¿Esto es una dieta o un estilo de alimentación?',
    description:
      'Es un plan estructurado pero realista. No es pasar hambre ni vivir contando gramos toda tu vida. Es aprender a comer de forma inteligente, flexible y sostenible.',
  },
  {
    title: '¿Incluye alimentos que sí pueda conseguir fácilmente?',
    description:
      'Sí. Trabajamos con alimentos comunes de supermercado. Nada raro, nada imposible de conseguir.',
  },
  {
    title: '¿Necesito cocinar recetas complicadas?',
    description:
      'No. El plan incluye comidas simples, rápidas y prácticas. No necesitas ser chef ni pasar horas en la cocina.',
  },
  {
    title: '¿Funciona aunque yo tenga poco tiempo o turnos rotativos?',
    description: 'Sí. El plan se adapta a tus horarios. No tú al plan.',
  },
  {
    title: '¿Sirve aunque yo no haga ejercicio?',
    description:
      'Sí. El plan se ajusta tanto a personas activas como a personas sedentarias. El ejercicio suma, pero no es obligatorio para comenzar a ver resultados.',
  },
  {
    title: '¿Voy a pasar hambre?',
    description:
      'No. Un plan bien hecho controla calorías sin hacerte sufrir. Comerás suficiente, aprenderás a saciarte mejor y a dejar de picar por ansiedad.',
  },
  {
    title: '¿Tengo que eliminar carbohidratos o comer solo proteínas?',
    description:
      'No obligatoriamente. El reparto de nutrientes se ajusta a tu cuerpo y objetivo, no a modas extremas.',
  },
  {
    title: '¿Sirve si tengo metabolismo lento?',
    description:
      'Sí. Muchas personas vienen con metabolismo dañado por dietas mal hechas. Aquí se busca reactivarlo, no castigarlo.',
  },
  {
    title: '¿Esto es una dieta keto?',
    description:
      'Solo si tú lo eliges. El plan se construye según tu preferencia y lo que mejor funcione para ti.',
  },
  {
    title: '¿Cuándo empezaré a notar cambios?',
    description:
      'Algunos sienten menos hinchazón y más energía en los primeros días. Cambios físicos visibles suelen empezar en las primeras 2–3 semanas.',
  },
  {
    title: '¿Cuánto peso puedo perder?',
    description:
      'Depende de tu punto de partida y constancia. No prometemos milagros: prometemos progreso real.',
  },
  {
    title: '¿Puedo comer fuera o socializar?',
    description:
      'Sí. Aprenderás a elegir mejor cuando comes fuera sin sabotear tu progreso.',
  },
  {
    title: '¿Incluye lista de compras?',
    description: 'Sí. Automática, clara y editable.',
  },
  {
    title: '¿Incluye recetas?',
    description:
      'Incluye combinaciones de comidas prácticas y sugerencias simples de preparación.',
  },
  {
    title: '¿Tengo soporte si tengo dudas?',
    description:
      'Sí. Acceso al equipo para ajustes y preguntas sobre tu plan a través del email info@fullmusculo.com.',
  },
  {
    title: '¿Esto es una dieta solo para adelgazar?',
    description:
      'No. El plan se ajusta a tu objetivo. Es un plan basado en comida real y densidad nutricional que también ayuda a reducir inflamación, mejorar digestión y recuperar energía.',
  },
  {
    title: '¿Esto sirve para hombres y mujeres?',
    description:
      'Sí. Adaptamos el plan según sexo, composición corporal y objetivo.',
  },
  {
    title: '¿Puedo usarlo si tomo medicación o tengo una condición médica?',
    description:
      'No sustituye tratamiento médico. Si tienes patología, el plan se ajusta para respetar tus limitaciones, pero siempre recomendamos seguir indicación profesional.',
  },
  {
    title: '¿Hay garantía?',
    description: 'Sí. Tienes 30 días para probar sin riesgo.',
  },
  {
    title: '¿Cuánto tiempo tengo acceso al plan?',
    description: 'Acceso completo e inmediato. Es tuyo.',
  },
  {
    title: '¿Es un único pago o una suscripción?',
    description: 'Pago único. Sin cuotas ocultas.',
  },
  {
    title: '¿Necesito báscula o herramientas especiales?',
    description: 'No. Solo ganas de empezar.',
  },
  {
    title: '¿Qué pasa si no me funciona?',
    description:
      'Si puedes probar que aplicaste el plan durante al menos 30 días continuos y no mejoraste en composición corporal, peso, saciedad, energía o salud general, te devolvemos el dinero. Deberás haber registrado todas tus comidas durante esos 30 días.',
  },
  {
    title: '¿Esto es igual que una app de dieta?',
    description:
      'No. Esto no es un algoritmo frío: es un plan humano, real y ajustado a ti.',
  },
]

class FaqsComponent extends Component {
  render() {
    return (
      <>
        <div className="faqs-header">
          <h3>¿Tienes preguntas?</h3>
          <h5>Tenemos las respuestas</h5>
        </div>
        <ul className="m-d expand-list">
          {faqs.map((faq, index) => (
            <>
              <li data-md-content="200">
                <label
                  name="tab"
                  for={`tab${index}`}
                  tabindex={index}
                  className="tab_lab"
                  role="tab"
                >
                  {faq.title}
                </label>
                <input
                  type="checkbox"
                  className="tab"
                  id={`tab${index}`}
                  tabindex={index}
                />
                <span className="open-close-icon">
                  <i className="fas fa-plus"></i>
                  <i className="fas fa-minus"></i>
                </span>
                <div className="content">{faq.description}</div>
              </li>
            </>
          ))}
        </ul>
      </>
    )
  }
}
export default FaqsComponent
